export default "__VITE_ASSET__Dn6f_vsa__"